/* eslint-disable no-use-before-define */
import React from "react";
// form
import { useFormContext, Controller } from "react-hook-form";
// hooks
import useResponsive from '../../hooks/useResponsive';
// @mui
import { Typography, TextField, Autocomplete, Box, Chip, Stack } from '@mui/material';

export default function RHFRoleSelect({ name, label, placeholder, options, position, onChange: ignored, helperText, mainRole, ...other }) {
  const { control } = useFormContext();
  const smUp = useResponsive('up', 'sm');
  
  return (
    <Controller
      name={name}
      control={control}
      render={(props) => (
        <Autocomplete
          multiple
          disableCloseOnSelect
          onChange={(_, values) => props.field.onChange(values)}
          options={options}
          value={props.field.value}
          getOptionLabel={(option) => `${option.short_name}`}
          isOptionEqualToValue={(option, value) => option.role === value.role}
          groupBy={(option) => option.group}
          renderGroup={(params) => (
            (position === 'developer')
            ? (
              <Stack direction={smUp ? "row" : "column"} key={params.group}>
                <Typography
                  variant="body2"
                  sx={{
                    pt: 1.6,
                    pr: smUp ? 2 : 0,
                    pl: smUp ? 0 : 1,
                    width: smUp ? '20%' : '100%',
                    textAlign: smUp ? 'right' : 'left',
                    fontWeight: 500
                  }}>
                  {params.group}
                </Typography>
                <Box sx={{ maxWidth: smUp ? '80%' : '100%', display: 'flex', flexWrap: 'wrap' }}>
                  {params.children}
                </Box>
              </Stack>
            ) : (
              <Stack direction={smUp ? "row" : "column"} key={params.group}>
                <Box sx={{ mx: smUp ? 2 : 1 , maxWidth: '100%', display: 'flex', flexWrap: 'wrap' }}>
                  {params.children}
                </Box>
              </Stack>
            )
          )}
          renderOption={(props, option, state) => (
            <Chip
              {...props}
              label={option.role}
              variant={state.selected ? "filled" : "outlined"}
              sx={{ borderRadius: 4 }}
              disabled={option.role === mainRole}
              />
          )}
          renderInput={(params) => (
            <TextField 
              {...params}
              fullWidth
              label={label}
              inputProps={{
                ...params.inputProps,
                readOnly: true,
                autoComplete: 'new-password', // disable autocomplete and autofill
              }}
              placeholder={placeholder}
              error={!!props.fieldState.error}
              helperText={props.fieldState.error?.message ? props.fieldState.error.message : helperText}
            />
          )}
          {...other}
        />
      )}
    />
  );
}
